import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { loadJsUrl } from '../const/loadJsUrl';
import { ecoType } from '../const';
import { loadScript } from '../tools';
/**
 * 转换接口协议, 使用与常规接口
 * 用法 wx.[protocolName](data)
 * @param {string} protocolName
 * @param {object} data
 * @returns Promise
 */

var defaultHandle = function defaultHandle(protocolName, data) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var protocolFn;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (window.wx) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return loadScript(loadJsUrl[ecoType], true);

            case 3:
              // if (!window.wx) return reject({ err_msg: protocolName + ':fail_not_config' });
              protocolFn = window.wx['protocolName'];

              if (!(typeof protocolFn !== 'function')) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", reject({
                err_msg: 'window.wx.' + protocolName + ':fail_notfind_protcol'
              }));

            case 6:
              protocolFn(_extends({}, data, {
                success: function success(res) {
                  resolve(res);
                },
                fail: function fail(err) {
                  reject(err);
                }
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
/**
 * 转换接口协议, 使用与invoke接口
 * 用法 wx.invoke(protocolName, data, callback)
 * @param {string} protocolName
 * @param {object} data
 * @returns Promise
 */


var invokeHandle = function invokeHandle(protocolName, data) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!window.wx || !window.wx.invoke)) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return loadScript(loadJsUrl[ecoType], true);

            case 3:
              // if (!window.wx || !window.wx.invoke) return reject({ err_msg: protocolName + ':fail_not_config' });
              window.wx.invoke(protocolName, data, function (res) {
                if (res.err_msg === protocolName + ':ok') {
                  resolve(res);
                } else {
                  reject(res);
                }
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
/**
 * 转换接口协议
 * @param {string} protocolName
 * @param {object} data
 * @param {object} isInvoke
 * @returns Promise
*/


var protocolHandle = function protocolHandle(protocolName, data, isInvoke) {
  if (isInvoke === void 0) {
    isInvoke = false;
  }

  var handle = isInvoke ? invokeHandle : defaultHandle;
  return handle(protocolName, data);
};

export default protocolHandle;